import { createAsyncAction } from 'typesafe-actions';

export const getProposalDetails = createAsyncAction(
  '@GET_PROPOSALDETAILS/REQUEST',
  '@GET_PROPOSALDETAILS/SUCCESS',
  '@GET_PROPOSALDETAILS/FAILURE'
)<undefined, Array<GQL.IProposalDetails>, string>();

export const getBilletProposal = createAsyncAction(
  '@GET_PROPOSALBILLET/REQUEST',
  '@GET_PROPOSALBILLET/SUCCESS',
  '@GET_PROPOSALBILLET/FAILURE'
)<
  {
    planId: number;
    proposalId: number;
    type: string;
    databaseId: number;
    callBack: (billet: {
      linhaDigitavel: string;
      nnumero: string;
      doc: string;
    }) => void;
  },
  string,
  string
>();

export const getLinhaDigitavelProposalBillet = createAsyncAction(
  '@GET_LINHADIGPROPOSALBILLET/REQUEST',
  '@GET_LINHADIGPROPOSALBILLET/SUCCESS',
  '@GET_LINHADIGPROPOSALBILLET/FAILURE'
)<
  {
    planId: number;
    proposalId: number;
    sendType: string;
    databaseId: number;
    callBack: (sendType: string, billet: GQL.IBillet) => void;
  },
  GQL.IBillet,
  string
>();
